import React, { useState, useEffect } from 'react';
import Typewriter from './Typewriter';
import profileImage from '../assets/image.png';

const Hero = () => {
  const [currentVisual, setCurrentVisual] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVisual((prev) => (prev + 1) % 2);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const roles = ['Computer Science Student', 'ML Engineer', 'Software Engineer', 'Problem Solver'];

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="greeting">Hi, I'm</span>
              <span className="name">Rahul Vuggumudi</span>
            </h1>
            <p className="hero-subtitle">
              <Typewriter words={roles} />
            </p>
            <p className="hero-description">
              Computer Science student at UT Austin passionate about machine learning, distributed systems, 
              and building scalable solutions. Currently interning at Amazon on the Nova AGI team.
            </p>
            <div className="hero-buttons">
              <a href="#projects" className="btn btn-primary" onClick={(e) => handleNavClick(e, 'projects')}>
                View My Work
              </a>
              <a href="#contact" className="btn btn-secondary" onClick={(e) => handleNavClick(e, 'contact')}>
                Get In Touch
              </a>
              <a 
                href="/Rahul-Vugg-Resume.pdf" 
                className="btn btn-resume" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i className="fas fa-file-pdf"></i> View Resume
              </a>
            </div>
            <div className="social-links">
              <a href="https://github.com/RahulV2478" aria-label="GitHub" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
              <a href="https://www.linkedin.com/in/rahul-vuggumudi-90561125b/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
              <a href="mailto:rahul.vuggumudi@gmail.com" aria-label="Email"><i className="fas fa-envelope"></i></a>
            </div>
          </div>
          <div className="hero-image">
            <div className="visual-carousel">
              {/* Code Block */}
              <div className={`visual-item ${currentVisual === 0 ? 'active' : ''}`}>
                <div className="code-animation">
                  <div className="code-block">
                    <div className="code-line">
                      <span className="code-keyword">def</span> <span className="code-function">build_future</span>():
                    </div>
                    <div className="code-line">
                      <span className="code-indent">    </span><span className="code-keyword">return</span> <span className="code-string">"Innovation"</span>
                    </div>
                    <div className="code-line">
                      <span className="code-keyword">class</span> <span className="code-class">Developer</span>:
                    </div>
                    <div className="code-line">
                      <span className="code-indent">    </span><span className="code-keyword">def</span> <span className="code-function">solve</span>(<span className="code-param">self</span>, problem):
                    </div>
                    <div className="code-line">
                      <span className="code-indent">        </span><span className="code-keyword">return</span> <span className="code-string">"Solution"</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Profile Image */}
              <div className={`visual-item ${currentVisual === 1 ? 'active' : ''}`}>
                <div className="profile-image-container">
                  <div className="profile-image-wrapper">
                    <img 
                      src={profileImage} 
                      alt="Rahul Vuggumudi" 
                      className="profile-image"
                    />
                    <div className="profile-image-glow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

